import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

// Network error patterns to suppress
const NETWORK_ERROR_PATTERNS = [
  'network error',
  'connection',
  'internet',
  'offline',
  'check your connection',
  'no internet',
  'failed to fetch',
];

/**
 * Check if a message is a network error message that should be suppressed
 */
const isNetworkErrorMessage = (message) => {
  if (!message || typeof message !== 'string') return false;
  const lowerMessage = message.toLowerCase();
  return NETWORK_ERROR_PATTERNS.some(pattern => lowerMessage.includes(pattern));
};

/**
 * Override toastr.error to suppress network error messages
 */
const originalError = toastr.error;
toastr.error = function(message, title, options) {
  if (isNetworkErrorMessage(message)) {
    console.log('Suppressed network error toastr:', message);
    return;
  }
  return originalError.call(this, message, title, options);
};

/**
 * Override toastr.warning to suppress network error messages
 */
const originalWarning = toastr.warning;
toastr.warning = function(message, title, options) {
  if (isNetworkErrorMessage(message)) {
    console.log('Suppressed network error toastr warning:', message);
    return;
  }
  return originalWarning.call(this, message, title, options);
};

// Configure default toastr options
toastr.options = {
  positionClass: 'toast-bottom-left',
  timeOut: 5000,
  closeButton: true,
  progressBar: true,
};

export default toastr;
